<h2 mat-dialog-title>
  {{ "DIAGNOSTIC.DEEP_DEBUG_SETTINGS.TITLE" | translate }}
</h2>

<form [formGroup]="form" (ngSubmit)="save()">
  <mat-dialog-content class="diagnostic-deep-debug-settings__content">
    <p class="diagnostic-deep-debug-settings__intro">
      {{ "DIAGNOSTIC.DEEP_DEBUG_SETTINGS.INTRO" | translate }}
    </p>

    <mat-form-field
      appearance="outline"
      class="diagnostic-deep-debug-settings__field"
    >
      <mat-label>{{
        "DIAGNOSTIC.DEEP_DEBUG_SETTINGS.REQUEST_BODY_LABEL" | translate
      }}</mat-label>
      <input
        matInput
        type="number"
        formControlName="requestBodyMaxChars"
        min="0"
        [max]="bodyMax"
      />
      <mat-hint>0 – {{ bodyMax }} byte</mat-hint>
    </mat-form-field>

    <mat-form-field
      appearance="outline"
      class="diagnostic-deep-debug-settings__field"
    >
      <mat-label>{{
        "DIAGNOSTIC.DEEP_DEBUG_SETTINGS.RESPONSE_BODY_LABEL" | translate
      }}</mat-label>
      <input
        matInput
        type="number"
        formControlName="responseBodyMaxChars"
        min="0"
        [max]="bodyMax"
      />
      <mat-hint>0 – {{ bodyMax }} byte</mat-hint>
    </mat-form-field>

    <div class="diagnostic-deep-debug-settings__toggle">
      <mat-slide-toggle formControlName="captureHeaders">
        {{ "DIAGNOSTIC.DEEP_DEBUG_SETTINGS.CAPTURE_HEADERS_LABEL" | translate }}
      </mat-slide-toggle>
    </div>

    <mat-form-field
      appearance="outline"
      class="diagnostic-deep-debug-settings__field"
    >
      <mat-label>{{
        "DIAGNOSTIC.DEEP_DEBUG_SETTINGS.MAX_EVENTS_LABEL" | translate
      }}</mat-label>
      <input
        matInput
        type="number"
        formControlName="maxEvents"
        [min]="eventsMin"
        [max]="eventsMax"
        step="100"
      />
      <mat-hint>{{ eventsMin }} – {{ eventsMax }}</mat-hint>
    </mat-form-field>

    <div
      *ngIf="showSizeWarning"
      role="alert"
      class="diagnostic-deep-debug-settings__warning"
    >
      {{ "DIAGNOSTIC.DEEP_DEBUG_SETTINGS.SIZE_WARNING" | translate }}
    </div>

    <div
      *ngIf="showEventsWarning"
      role="alert"
      class="diagnostic-deep-debug-settings__warning"
    >
      {{ "DIAGNOSTIC.DEEP_DEBUG_SETTINGS.EVENTS_WARNING" | translate }}
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button type="button" (click)="resetToDefault()">
      {{ "DIAGNOSTIC.DEEP_DEBUG_SETTINGS.RESET" | translate }}
    </button>
    <button mat-button type="button" (click)="cancel()">
      {{ "DIALOG.CANCEL" | translate }}
    </button>
    <button
      mat-flat-button
      color="primary"
      type="submit"
      [disabled]="form.invalid"
    >
      {{ "DIAGNOSTIC.DEEP_DEBUG_SETTINGS.SAVE" | translate }}
    </button>
  </mat-dialog-actions>
</form>
